/**
 * Admin Answers page component.
 *
 * Route: `/admin/answers`
 * Requires authentication: Yes (admin only)
 *
 * @module AdminAnswersPage
 */

import AnswersManager from '@/components/admin/AnswersManager';

export default function AdminAnswersPage() {
  return <AnswersManager />;
}
